import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerSections = {
    'ALL PRODUCTS': [
      { name: 'STAYS', path: '/stays' },
      { name: 'EVENTS', path: '/events' },
      { name: 'OFFERS', path: '/offers' }
    ],
    'SUPPORT': [
      { name: 'CONTACT US', path: '/contact' },
      { name: 'HELP CENTRE', path: '/help' },
      { name: 'FAQ', path: '/faq' }
    ],
    'LEGAL': [
      { name: 'PRIVACY POLICY', path: '/privacy' },
      { name: 'TERMS AND CONDITIONS', path: '/terms' },
      { name: 'RETURNS, REFUNDS & CANCELLATION', path: '/return-refund-cancellation' }
    ],
    'BFP THINGS': [
      { name: 'ABOUT US', path: '/about' }
    ]
  };

  return (
    <footer className="bg-[#FF5E4C] text-white">
      <div className="w-full lg:px-[120px] md:px-[60px] px-[20px] py-[100px]">
        {/* Footer Links */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-[40px]">
          {Object.entries(footerSections).map(([title, links]) => (
            <div className="w-fit" key={title}>
              <h3 className="font-bold text-white mb-[17px] md:mb-[14px] tracking-wide text-[14px]">{title}</h3>
              <ul className="space-y-[15px]">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link 
                      to={link.path}
                      className="text-white text-[14px] hover:opacity-80 transition-opacity font-normal"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Dotted Separator */}
        <div className="border-t border-dotted border-white border-opacity-50 mb-[40px]"></div>

        {/* Bottom Section */}
        <div className="flex flex-col flex-col-reverse lg:flex-row items-start justify-between">
          {/* Logo */}
          <div className="mb-[40px] lg:mb-0">
            <Link to="/" aria-label="Go to homepage">
              <img 
                src="/assets/BFPlogo.png" 
                alt="Book For Paws Logo" 
                className="w-full  md:max-h-[300px]"
              />
            </Link>
          </div>

          {/* Copyright Info */}
          <div className="text-right w-full flex flex-col items-center md:items-end mb-[20px]">
            <div className="text-white text-sm mb-[25px]">EST 2025 ©</div>
            <div className="text-white text-sm">BOOKFORPAWS.COM</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 